// removed by extract-text-webpack-plugin
module.exports = {"welcome-page-wrapper":"welcome-module-welcome-page-wrapper-0ca2114df2c2886898b0f189ce90e565--","welcome-container":"welcome-module-welcome-container-0a40470c2937f5f08108db92ee4f7d10--","title":"welcome-module-title-b05e38872ed2bab5275eceb8b74d5ff1--","info-text":"welcome-module-info-text-b3743d5350700661cf44bebd22600581--","start-button-text":"welcome-module-start-button-text-f1dbe47cb7b014fa83aec06f2eacfdf2--","line":"welcome-module-line-3cadaf4fadee351c85bad5edc637b99e--"};


//////////////////
// WEBPACK FOOTER
// /src/components/intro/pages/welcome/welcome.module.scss
// module id = 2011
// module chunks = 0